import React, { useEffect } from "react";
import mapboxgl from "mapbox-gl";

import US_STATES_DATA from "../data/US_STATES";

interface StatesLayerProps {
   /** Ref to MapBox Map where to draw borders */
   map: mapboxgl.Map;
}

const SOURCE_STATES_NAME = "default-source-states";
const LAYER_BORDER_STATES_NAME = "default-layer-state-borders";

/** US State borders */
const DefaultStatesLayer: React.FC<StatesLayerProps> = ({ map }) => {
    useEffect(() => {
        map.addSource(SOURCE_STATES_NAME, {
            type: "geojson",
            data: US_STATES_DATA,
        });

        map.addLayer({
            id: LAYER_BORDER_STATES_NAME,
            type: "line",
            source: SOURCE_STATES_NAME,
            paint: {
                "line-color": "#cfd2d4",
                "line-width": 0.5,
            },
        });

        return () => {
            map.removeLayer(LAYER_BORDER_STATES_NAME);
            map.removeSource(SOURCE_STATES_NAME);
        };
    }, [map]);

   return null;
};

export default DefaultStatesLayer;